module.exports = __webpack_public_path__ + "img/9.df7de1c1.png";